import * as z from 'zod';

const urlLength = 2048;

export const createStringValidator = (
  minLength: number,
  maxLength: number,
  fieldName: string,
) =>
  z
    .string()
    .trim()
    .min(
      minLength,
      `${fieldName} must be at least ${minLength} character(s) long`,
    )
    .max(maxLength, `${fieldName} cannot exceed ${maxLength} characters`);

export const urlValidator = z
  .string()
  .trim()
  .min(1, 'URL is required')
  .max(urlLength, `URL cannot exceed ${urlLength} characters`)
  .url('Must be a valid URL format')
  .refine((url) => {
    const dangerousProtocols = ['javascript:', 'data:', 'vbscript:', 'file:'];
    const lowerUrl = url.toLowerCase();
    return !dangerousProtocols.some((protocol) =>
      lowerUrl.startsWith(protocol),
    );
  }, 'URL contains unsafe protocol');

export const optionalUrlValidator = z
  .string()
  .trim()
  .max(urlLength, `Image URL cannot exceed ${urlLength} characters`)
  .url('Must be a valid URL format')
  .refine((url) => {
    const dangerousProtocols = ['javascript:', 'data:', 'vbscript:', 'file:'];
    const lowerUrl = url.toLowerCase();
    return !dangerousProtocols.some((protocol) =>
      lowerUrl.startsWith(protocol),
    );
  }, 'Image URL contains unsafe protocol')
  .optional()
  .or(z.literal('').transform(() => null));
export const idValidator = z.string().uuid('ID must be a valid UUID format');
